import {useState} from 'react'
import Style from '../style'
import DefaultButton from 'shared/ui/DefaultButton'
import {pwRegx} from 'shared/lib/inputValidation'

const ChangePasswordModal = ({isOpen, onClose, onSubmit, isLoading}) => {
	const [newPassword, setNewPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [passwordError, setPasswordError] = useState('')
	const [confirmError, setConfirmError] = useState('')

	const handleSubmit = () => {
		let hasError = false

		if (!newPassword) {
			setPasswordError('비밀번호를 입력하세요')
			hasError = true
		} else if (!pwRegx.test(newPassword)) {
			setPasswordError(
				'비밀번호는 문자, 숫자, 특수문자를 각각 최소 1개 포함해야 합니다'
			)
			hasError = true
		} else {
			setPasswordError('')
		}

		if (!confirmPassword) {
			setConfirmError('비밀번호를 다시 입력하세요')
			hasError = true
		} else if (newPassword !== confirmPassword) {
			setConfirmError('비밀번호가 일치하지 않습니다')
			hasError = true
		} else {
			setConfirmError('')
		}

		if (hasError) return

		onSubmit(newPassword)
		handleClose()
	}

	const handleClose = () => {
		setNewPassword('')
		setConfirmPassword('')
		setPasswordError('')
		setConfirmError('')
		onClose()
	}

	if (!isOpen) return null

	return (
		<Style.ModalOverlay onClick={handleClose}>
			<Style.ModalContent onClick={(e) => e.stopPropagation()}>
				<Style.ModalHeader>
					<h2>비밀번호 변경</h2>
				</Style.ModalHeader>
				<Style.ModalBody>
					<div>
						<Style.Input
							type='password'
							placeholder='새 비밀번호를 입력하세요'
							value={newPassword}
							onChange={(e) => {
								setNewPassword(e.target.value)
								setPasswordError('')
							}}
							onBlur={() => {
								if (!newPassword) {
									setPasswordError('비밀번호를 입력하세요')
								} else if (!pwRegx.test(newPassword)) {
									setPasswordError(
										'비밀번호는 문자, 숫자, 특수문자를 각각 최소 1개 포함해야 합니다'
									)
								}
							}}
						/>
						{passwordError && (
							<Style.ErrorText>{passwordError}</Style.ErrorText>
						)}
					</div>
					<div>
						<Style.InputGroup>
							<Style.Input
								type='password'
								placeholder='비밀번호를 다시 입력하세요'
								value={confirmPassword}
								onChange={(e) => {
									setConfirmPassword(e.target.value)
									setConfirmError('')
								}}
								onBlur={() => {
									if (!confirmPassword) {
										setConfirmError('비밀번호를 다시 입력하세요')
									} else if (newPassword !== confirmPassword) {
										setConfirmError('비밀번호가 일치하지 않습니다')
									}
								}}
							/>
							<DefaultButton
								clickEvent={handleSubmit}
								small
								loading={isLoading}
							>
								변경
							</DefaultButton>
						</Style.InputGroup>
						{confirmError && <Style.ErrorText>{confirmError}</Style.ErrorText>}
					</div>
				</Style.ModalBody>
			</Style.ModalContent>
		</Style.ModalOverlay>
	)
}

export default ChangePasswordModal
